export default __webpack_public_path__ + "static/NBInternationalPro-Bold-465670eb923c81c2a14f1ec951b5d9c4.woff";